<script setup lang="ts">
import { OdsButton } from "@ods/lidl-web-vuejs";

defineProps<{
  ctaText: string;
  ctaHref: string;
}>();
</script>

<template>
  <div class="reco-overlay">
    <OdsButton as="a" :href="ctaHref" :label="ctaText" level="secondary" />
  </div>
</template>

<style lang="scss" scoped>
.reco-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;
}
</style>
